export default __webpack_public_path__ + "static/uqam-2ecc762213a086c0b5bdee243a2cc253.jpg";